import React, {useContext, useEffect, useState} from 'react';
import {init} from "./call&logic/logicAndCall";
import AssociationDesktop from "./components/Desktop";
import AssociationMobile from "./components/Mobile";
import {WMSContext} from "../context/WMSContext";

function WmsAssociations() {
    const {currentInventory, isMobile} = useContext(WMSContext)
    const [associationList, setAssociationList] = useState([])

    const handleForceReload = (page) => {
        init(currentInventory.id, page).then(response => {
            if (response.items.length > 0) {
                setAssociationList(response)
            } else {
                setAssociationList([])
            }
        })
    }

    useEffect(() => {
        if (currentInventory) {
            init(currentInventory.id).then(response => {
                if (response.items.length > 0) {
                    setAssociationList(response)
                } else {
                    setAssociationList([])
                }

            })
        }
    }, [currentInventory, isMobile]);
    return (
        <>
            {associationList && !isMobile && (
                <AssociationDesktop
                    associationList={associationList}
                    forceReload={handleForceReload}
                 />
            )}

            {associationList && isMobile && (
                <AssociationMobile
                    associationList={associationList}
                    forceReload={handleForceReload}
                />
            )}
        </>
    );
}

export default WmsAssociations;